export class FacetAction extends HTMLElement {
    constructor() {
        super()
    }

    updateURLHash(url: string) {
        history.pushState({}, '', url);
    }

    fetchPageContent(url: string) {
        this.toggleCollectionLoading("open");

        fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
            this.renderCollectionContent(responseText);
            this.toggleCollectionLoading("close");
        });
    }

    toggleCollectionLoading(state: string) {
        const collectionSection = document.querySelector(".collection");
        if(state == "open") {
            collectionSection?.classList.add("loading");
        }
        else {
            const closeButton = document.querySelector("facet-mobile-drawer .collection__facets-draw-heading .close") as HTMLElement;
            closeButton?.click();
        }
    }

    renderCollectionContent(html: string) {
        const sectionInnerHtml = this.getSectionInnerHTML(html, ".collection") as string;
        const collectionSection = document.querySelector(".collection") as HTMLElement;
        collectionSection.outerHTML = sectionInnerHtml;
    }

    getSectionInnerHTML(html: string, selector: string) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.outerHTML;
    }
}

customElements.define('facet-options', FacetAction);


